import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Tasks() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  return <ListItem button onClick={() => {
    history.push("/tasks");
    dispatch(showSidebar(false));
  }}>
    <ListItemIcon><AssignmentIcon /></ListItemIcon>
    <ListItemText primary={t("tasks.header")} />
  </ListItem>;
}
